import React from "react";
import './style.scss'

const Loading = () => (
    <div className='loadingSpinner_wrapper'>
            <div className="loadingSpinner"/>
    </div>
)

export default Loading